import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints, fontWeights, colors } from '@/styles'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Box } from '@/components/structure'

const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 40px 0;

  // use after for bottom padding due to Firefox bug:
  // https://stackoverflow.com/questions/29986977
  :after {
    content: '';
    display: block;
    padding-bottom: 50px;
    width: 100%;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 10px 20px 0;
  }
`

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 685px;
  width: 100%;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    width: unset;
  }
`

const Title = styled.h1`
  font-size: 20px;
  font-weight: ${fontWeights.bold};
  letter-spacing: -0.2px;
  line-height: 28px;
  text-align: center;
  margin: 0 0 24px;
`

const Description = styled.p`
  font-size: 14px;
  color: ${colors.mediumGrey};
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.2px;
  line-height: 20px;
  text-align: center;
  max-width: 500px;
  margin: 24px 0 40px;

  span {
    display: block;
    text-align: left;
    :not(:last-child) {
      margin-bottom: 20px;
    }
  }

  strong {
    font-weight: ${fontWeights.bold};
  }
`

const Image = styled.img`
  height: ${props => props.imageHeight};
  width: auto;
`

const TrustScoreInfoModal = ({ title, description, image, imageHeight = '168px' }) => {
  const { close } = useModalize()
  const { t } = useTranslation()

  return (
    <ContentWrapper>
      <ContentInner>
        <Title>{title}</Title>
        <Image src={image} alt="" imageHeight={imageHeight} />
        <Description>{description}</Description>
        <Box width="156px">
          <Button theme="primary" onClick={close}>
            {t('b.liv_score.view.got_it.button', 'Got it')}
          </Button>
        </Box>
      </ContentInner>
    </ContentWrapper>
  )
}

export const showTrustScoreInfoModal = createModal(TrustScoreInfoModal, {
  width: '640px'
})
